// Tailwind's own `animate-bounce` (https://tailwindcss.com/docs/animation#adding-a-bounce-animation)
// loops that same one-second bounce forever, which reads as constant motion rather than a
// periodic "hey, look here" nudge. This repeats that single-beat bounce shape twice back to
// back in the front 1.5s of an 8s cycle (18.75%), holding still (0 translateY) for the
// remaining 6.5s - looping the whole cycle `infinite` gives two quick bounces every 8s.
export const UNREAD_INDICATOR_BOUNCE_KEYFRAMES = `
  @keyframes sunny-chat-unread-bounce {
    0%, 9.375%, 18.75%, 100% {
      transform: translateY(0);
      animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
    4.6875%,
    14.0625% {
      transform: translateY(-10px);
      animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
    }
  }
`;
export const UNREAD_INDICATOR_BOUNCE_CLASS = '[animation:sunny-chat-unread-bounce_8s_infinite]';
